var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMenuDotsVerticalCircle = function SvgMenuDotsVerticalCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 5C8.24594 5 5 8.24594 5 12.25C5 16.2541 8.24594 19.5 12.25 19.5C16.2541 19.5 19.5 16.2541 19.5 12.25C19.5 8.24594 16.2541 5 12.25 5ZM3 12.25C3 7.14137 7.14137 3 12.25 3C17.3586 3 21.5 7.14137 21.5 12.25C21.5 17.3586 17.3586 21.5 12.25 21.5C7.14137 21.5 3 17.3586 3 12.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1638 8.41378C11.1638 9.02129 11.6563 9.51378 12.2638 9.51378C12.8713 9.51378 13.3638 9.0213 13.3638 8.41378C13.3638 7.80627 12.8713 7.31378 12.2638 7.31378C11.6563 7.31378 11.1638 7.80627 11.1638 8.41378Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1364 12.2638C11.1364 12.8713 11.6289 13.3638 12.2364 13.3638C12.8439 13.3638 13.3364 12.8713 13.3364 12.2638C13.3364 11.6562 12.8439 11.1638 12.2364 11.1638C11.6289 11.1638 11.1364 11.6562 11.1364 12.2638Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1638 16.1138C11.1638 16.7213 11.6563 17.2138 12.2638 17.2138C12.8713 17.2138 13.3638 16.7213 13.3638 16.1138C13.3638 15.5063 12.8713 15.0138 12.2638 15.0138C11.6563 15.0138 11.1638 15.5063 11.1638 16.1138Z",
    fill: "black"
  })));
};
export { SvgMenuDotsVerticalCircle as ReactComponent };
export default __webpack_public_path__ + "static/media/menu-dots-vertical-circle.e9448e9a.svg";